import React from 'react';
import './blogcard.css';


const Functional = () => {
    
  return (
    <div> 
        <h1 className="master-web-title"> Functional </h1>
    </div>
  )
}

export default Functional;
